module.exports = __webpack_public_path__ + "static/media/AHW_04.fe2a34f2.jpg";